import { render, staticRenderFns } from "./reclamo.vue?vue&type=template&id=49915aa4&"
import script from "./reclamo.vue?vue&type=script&lang=js&"
export * from "./reclamo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports